/*
 * @Author: Girish Akhare
 * @Date: 2021-02-04 12:37:39
 * @Last Modified by: Girish Akhare
 * @Last Modified time: 2022-01-17 17:00:19
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { CustomSelectComponent } from './select/select.component';
import { ConditionalWrapperModule } from '../conditional-wrapper/conditional-wrapper.module';
import { CustomToolTipModule } from '../tool-tip/custom_tool-tip.module';

/**
 * Components which need to declared and export added here...
 */
const Components = [
  CustomSelectComponent,
];

@NgModule({
  imports: [
    FormsModule,
    CommonModule,
    NgSelectModule,
    ConditionalWrapperModule,
    CustomToolTipModule
  ],
  exports: Components,
  declarations: Components,
  providers: []
})
export class CustomFormModule {}
